import localStyles from './styles.module.scss';
import styles from '../styles.module.scss';

import React, {useEffect, useRef, useState} from "react";
import {useAppData} from "../../context/Contexts";
import {useLocalStorage} from "../../hooks/useLocalStorage";

const Bonus3Section: React.FC = (props) => {
    const {currentAppData, setCurrentAppData} = useAppData();
    const [source, setSource] = useLocalStorage("source", "");

    /*useEffect(() => {
        if (source == 'fb1') {
            setCurrentAppData(prevState => {
                return { ...prevState, with_bonus: true }
            })
        }
    }, [source]);

    function onChange() {
        setCurrentAppData(prevState => {
            return { ...prevState, with_bonus: !prevState?.with_bonus }
        })
    }*/

    //console.log('source=', source);

    return window.scs_show_new_year_promo_section ?

        (<div className={`free_bonus ${localStyles.bonus3_section}`}>

            <h3 dangerouslySetInnerHTML={{__html: `${window.scs_section_title}`}}></h3>
            <ul className={`${localStyles.bonus_items}`}>
                <li className={localStyles.active}>
                    <div className={localStyles.enabled} style={{ position: "relative",
                        overflow: "hidden", border: 0 }}>
                        <img
                            src={`${window.scs_bonus_section_img_1}`}
                            alt={`${window.scs_bonus_section_img_1_alt}`} style={{ height: "100%",
                            width: "100%",
                            position: "absolute",
                            top: 0,
                            left: 0,
                            objectFit: "cover" }} />
                    </div>
                    <p dangerouslySetInnerHTML={{__html: `${window.scs_bonus_section_img_1_title}`}}></p>
                </li>
                <li className={localStyles.active}>
                    <div className={localStyles.price}>
                        <s>{ window.scs_bonus_section_price_2 }</s> FREE
                    </div>
                    <div className={localStyles.enabled}>
                        <img src={`${window.scs_bonus_section_img_2}`}
                             alt={`${window.scs_bonus_section_img_2_alt}`}/>

                    </div>
                    <div className={localStyles.disabled}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" viewBox="0 0 20 27" fill="none">
                            <path
                                d="M17.5 10.2458H16.6667V6.91252C16.6667 3.23585 13.6767 0.24585 10 0.24585C6.32333 0.24585 3.33333 3.23585 3.33333 6.91252V10.2458H2.5C1.12222 10.2458 0 11.367 0 12.7458V24.4125C0 25.7914 1.12222 26.9125 2.5 26.9125H17.5C18.8778 26.9125 20 25.7914 20 24.4125V12.7458C20 11.367 18.8778 10.2458 17.5 10.2458ZM5.55556 6.91252C5.55556 4.4614 7.54889 2.46807 10 2.46807C12.4511 2.46807 14.4444 4.4614 14.4444 6.91252V10.2458H5.55556V6.91252ZM11.1111 18.8258V21.357C11.1111 21.9703 10.6144 22.4681 10 22.4681C9.38556 22.4681 8.88889 21.9703 8.88889 21.357V18.8258C8.22778 18.4403 7.77778 17.7314 7.77778 16.9125C7.77778 15.687 8.77444 14.6903 10 14.6903C11.2256 14.6903 12.2222 15.687 12.2222 16.9125C12.2222 17.7314 11.7722 18.4403 11.1111 18.8258Z"
                                fill="#737373"/>
                        </svg>
                        Locked
                    </div>
                    <p dangerouslySetInnerHTML={{__html: `${window.scs_bonus_section_img_2_title}`}}></p>
                </li>

                <li className={localStyles.active}>
                    <div className={localStyles.price}>
                        <s>{window.scs_bonus_section_price_3}</s> FREE
                    </div>
                    <div className={localStyles.enabled}>
                        <img src={`${window.scs_bonus_section_img_3}`}
                             alt={`${window.scs_bonus_section_img_3_alt}`} style={{maxWidth: '106px'}}/>

                    </div>
                    <div className={localStyles.disabled}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" viewBox="0 0 20 27" fill="none">
                            <path
                                d="M17.5 10.2458H16.6667V6.91252C16.6667 3.23585 13.6767 0.24585 10 0.24585C6.32333 0.24585 3.33333 3.23585 3.33333 6.91252V10.2458H2.5C1.12222 10.2458 0 11.367 0 12.7458V24.4125C0 25.7914 1.12222 26.9125 2.5 26.9125H17.5C18.8778 26.9125 20 25.7914 20 24.4125V12.7458C20 11.367 18.8778 10.2458 17.5 10.2458ZM5.55556 6.91252C5.55556 4.4614 7.54889 2.46807 10 2.46807C12.4511 2.46807 14.4444 4.4614 14.4444 6.91252V10.2458H5.55556V6.91252ZM11.1111 18.8258V21.357C11.1111 21.9703 10.6144 22.4681 10 22.4681C9.38556 22.4681 8.88889 21.9703 8.88889 21.357V18.8258C8.22778 18.4403 7.77778 17.7314 7.77778 16.9125C7.77778 15.687 8.77444 14.6903 10 14.6903C11.2256 14.6903 12.2222 15.687 12.2222 16.9125C12.2222 17.7314 11.7722 18.4403 11.1111 18.8258Z"
                                fill="#737373"/>
                        </svg>
                        Locked
                    </div>
                    <p dangerouslySetInnerHTML={{__html: `${window.scs_bonus_section_img_3_title}`}}></p>
                </li>


            </ul>

        </div>)


        : window.scs_show_bf_section ? (
                <div className={`free_bonus ${localStyles.free_bonus_2_prods} ${localStyles.bonus3_section}`}>


                    <ul className={`${localStyles.bonus_items}`}>
                        <li className={`${localStyles.active} cols-2`}>
                            <div className={localStyles.enabled}>
                                <img
                                    src={window.scs_bonus_section_img_1}
                                    alt={window.scs_bonus_section_img_1_alt}/>
                            </div>
                            <p dangerouslySetInnerHTML={{__html: `${window.scs_bonus_section_img_1_title}`}}></p>
                        </li>
                        <li className={localStyles.active}>
                            <div className={localStyles.price}>
                                <s>{window.scs_bonus_section_price}</s> FREE
                            </div>
                            <div className={localStyles.enabled}>
                                <img src={window.scs_bonus_section_img_2}
                                     alt={window.scs_bonus_section_img_2_alt}/>

                            </div>
                            <div className={localStyles.disabled}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" viewBox="0 0 20 27"
                                     fill="none">
                                    <path
                                        d="M17.5 10.2458H16.6667V6.91252C16.6667 3.23585 13.6767 0.24585 10 0.24585C6.32333 0.24585 3.33333 3.23585 3.33333 6.91252V10.2458H2.5C1.12222 10.2458 0 11.367 0 12.7458V24.4125C0 25.7914 1.12222 26.9125 2.5 26.9125H17.5C18.8778 26.9125 20 25.7914 20 24.4125V12.7458C20 11.367 18.8778 10.2458 17.5 10.2458ZM5.55556 6.91252C5.55556 4.4614 7.54889 2.46807 10 2.46807C12.4511 2.46807 14.4444 4.4614 14.4444 6.91252V10.2458H5.55556V6.91252ZM11.1111 18.8258V21.357C11.1111 21.9703 10.6144 22.4681 10 22.4681C9.38556 22.4681 8.88889 21.9703 8.88889 21.357V18.8258C8.22778 18.4403 7.77778 17.7314 7.77778 16.9125C7.77778 15.687 8.77444 14.6903 10 14.6903C11.2256 14.6903 12.2222 15.687 12.2222 16.9125C12.2222 17.7314 11.7722 18.4403 11.1111 18.8258Z"
                                        fill="#737373"/>
                                </svg>
                                Locked
                            </div>
                            <p dangerouslySetInnerHTML={{__html: `${window.scs_bonus_section_img_2_title}`}}></p>
                        </li>


                    </ul>

                </div>) :
            (window.scs_show_earlybf_section || window.scs_show_bf_section ? (
                <div className={`free_bonus ${localStyles.free_bonus_2_prods} ${localStyles.bonus3_section}`}>


                    <ul className={`${localStyles.bonus_items}`}>
                        <li className={localStyles.active}>
                            <div className={localStyles.enabled}>
                                <img
                                    src="https://cdn.shopify.com/s/files/1/0732/5909/0212/files/promote.png?v=1731701982"
                                    alt=""/>
                            </div>
                            <p>Early Black Friday<br/>Special</p>
                        </li>
                        <li className={localStyles.active}>
                            <div className={localStyles.price}>
                                <s>$39.99</s> FREE
                            </div>
                            <div className={localStyles.enabled}>
                                <img
                                    src="//www.seatcoversolutions.com/cdn/shop/t/7/assets/luxe-seat-cover-care-bundle.png"
                                    alt="Luxe Seat & Interior Care Kit"/>

                            </div>
                            <div className={localStyles.disabled}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" viewBox="0 0 20 27" fill="none">
                                    <path
                                        d="M17.5 10.2458H16.6667V6.91252C16.6667 3.23585 13.6767 0.24585 10 0.24585C6.32333 0.24585 3.33333 3.23585 3.33333 6.91252V10.2458H2.5C1.12222 10.2458 0 11.367 0 12.7458V24.4125C0 25.7914 1.12222 26.9125 2.5 26.9125H17.5C18.8778 26.9125 20 25.7914 20 24.4125V12.7458C20 11.367 18.8778 10.2458 17.5 10.2458ZM5.55556 6.91252C5.55556 4.4614 7.54889 2.46807 10 2.46807C12.4511 2.46807 14.4444 4.4614 14.4444 6.91252V10.2458H5.55556V6.91252ZM11.1111 18.8258V21.357C11.1111 21.9703 10.6144 22.4681 10 22.4681C9.38556 22.4681 8.88889 21.9703 8.88889 21.357V18.8258C8.22778 18.4403 7.77778 17.7314 7.77778 16.9125C7.77778 15.687 8.77444 14.6903 10 14.6903C11.2256 14.6903 12.2222 15.687 12.2222 16.9125C12.2222 17.7314 11.7722 18.4403 11.1111 18.8258Z"
                                        fill="#737373"/>
                                </svg>
                                Locked
                            </div>
                            <p>Luxe Seat &<br/> Interior Care Kit</p>
                        </li>

                        <li className={localStyles.active}>
                            <div className={localStyles.price}>
                                <s>19.95</s> FREE
                            </div>
                            <div className={localStyles.enabled}>
                                <img src="//www.seatcoversolutions.com/cdn/shop/t/7/assets/luxe-microfiber-towel.png"
                                     alt="Luxe Microfiber Towel"/>

                            </div>
                            <div className={localStyles.disabled}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" viewBox="0 0 20 27" fill="none">
                                    <path
                                        d="M17.5 10.2458H16.6667V6.91252C16.6667 3.23585 13.6767 0.24585 10 0.24585C6.32333 0.24585 3.33333 3.23585 3.33333 6.91252V10.2458H2.5C1.12222 10.2458 0 11.367 0 12.7458V24.4125C0 25.7914 1.12222 26.9125 2.5 26.9125H17.5C18.8778 26.9125 20 25.7914 20 24.4125V12.7458C20 11.367 18.8778 10.2458 17.5 10.2458ZM5.55556 6.91252C5.55556 4.4614 7.54889 2.46807 10 2.46807C12.4511 2.46807 14.4444 4.4614 14.4444 6.91252V10.2458H5.55556V6.91252ZM11.1111 18.8258V21.357C11.1111 21.9703 10.6144 22.4681 10 22.4681C9.38556 22.4681 8.88889 21.9703 8.88889 21.357V18.8258C8.22778 18.4403 7.77778 17.7314 7.77778 16.9125C7.77778 15.687 8.77444 14.6903 10 14.6903C11.2256 14.6903 12.2222 15.687 12.2222 16.9125C12.2222 17.7314 11.7722 18.4403 11.1111 18.8258Z"
                                        fill="#737373"/>
                                </svg>
                                Locked
                            </div>
                            <p>Luxe Microfiber <br/>Towel</p>
                        </li>


                    </ul>

                </div>) : (
                <div className={`free_bonus ${localStyles.bonus3_section}`}>


                    <ul className={`${localStyles.bonus_items}`}>
                        <li className={currentAppData?.seat && (currentAppData?.seat?.indexOf('Bundle') !== -1 ? localStyles.active : '')}>
                            <div className={localStyles.price}>
                                <s>$39.99</s> FREE
                            </div>
                            <div className={localStyles.enabled}>
                                <img src="//www.seatcoversolutions.com/cdn/shop/t/7/assets/luxe-seat-cover-care-bundle.png"
                                     alt="Luxe Seat & Interior Care Kit"/>

                            </div>
                            <div className={localStyles.disabled}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" viewBox="0 0 20 27" fill="none">
                                    <path
                                        d="M17.5 10.2458H16.6667V6.91252C16.6667 3.23585 13.6767 0.24585 10 0.24585C6.32333 0.24585 3.33333 3.23585 3.33333 6.91252V10.2458H2.5C1.12222 10.2458 0 11.367 0 12.7458V24.4125C0 25.7914 1.12222 26.9125 2.5 26.9125H17.5C18.8778 26.9125 20 25.7914 20 24.4125V12.7458C20 11.367 18.8778 10.2458 17.5 10.2458ZM5.55556 6.91252C5.55556 4.4614 7.54889 2.46807 10 2.46807C12.4511 2.46807 14.4444 4.4614 14.4444 6.91252V10.2458H5.55556V6.91252ZM11.1111 18.8258V21.357C11.1111 21.9703 10.6144 22.4681 10 22.4681C9.38556 22.4681 8.88889 21.9703 8.88889 21.357V18.8258C8.22778 18.4403 7.77778 17.7314 7.77778 16.9125C7.77778 15.687 8.77444 14.6903 10 14.6903C11.2256 14.6903 12.2222 15.687 12.2222 16.9125C12.2222 17.7314 11.7722 18.4403 11.1111 18.8258Z"
                                        fill="#737373"/>
                                </svg>
                                Locked
                            </div>
                            <p>Luxe Seat &<br/> Interior Care Kit</p>
                        </li>

                        <li className={currentAppData?.seat && (currentAppData?.seat?.indexOf('Bundle') !== -1 || currentAppData?.seat?.indexOf('Front') !== -1 ? localStyles.active : '')}>
                            <div className={localStyles.price}>
                                <s>19.95</s> FREE
                            </div>
                            <div className={localStyles.enabled}>
                                <img src="//www.seatcoversolutions.com/cdn/shop/t/7/assets/luxe-microfiber-towel.png"
                                     alt="Luxe Microfiber Towel"/>

                            </div>
                            <div className={localStyles.disabled}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" viewBox="0 0 20 27" fill="none">
                                    <path
                                        d="M17.5 10.2458H16.6667V6.91252C16.6667 3.23585 13.6767 0.24585 10 0.24585C6.32333 0.24585 3.33333 3.23585 3.33333 6.91252V10.2458H2.5C1.12222 10.2458 0 11.367 0 12.7458V24.4125C0 25.7914 1.12222 26.9125 2.5 26.9125H17.5C18.8778 26.9125 20 25.7914 20 24.4125V12.7458C20 11.367 18.8778 10.2458 17.5 10.2458ZM5.55556 6.91252C5.55556 4.4614 7.54889 2.46807 10 2.46807C12.4511 2.46807 14.4444 4.4614 14.4444 6.91252V10.2458H5.55556V6.91252ZM11.1111 18.8258V21.357C11.1111 21.9703 10.6144 22.4681 10 22.4681C9.38556 22.4681 8.88889 21.9703 8.88889 21.357V18.8258C8.22778 18.4403 7.77778 17.7314 7.77778 16.9125C7.77778 15.687 8.77444 14.6903 10 14.6903C11.2256 14.6903 12.2222 15.687 12.2222 16.9125C12.2222 17.7314 11.7722 18.4403 11.1111 18.8258Z"
                                        fill="#737373"/>
                                </svg>
                                Locked
                            </div>
                            <p>Luxe Microfiber <br/>Towel</p>
                        </li>
                        <li className={currentAppData?.seat && (currentAppData?.seat?.indexOf('Bundle') !== -1 || currentAppData?.seat?.indexOf('Back') !== -1 || currentAppData?.seat?.indexOf('Front') !== -1 ? localStyles.active : '')}>
                            <div className={localStyles.price}>
                                <s>$11.99</s> FREE
                            </div>
                            <div className={localStyles.enabled}>
                                <img src="//www.seatcoversolutions.com/cdn/shop/t/7/assets/trio.png"
                                     alt="Scented Trio - Air Fresheners"/>
                            </div>
                            <div className={localStyles.disabled}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" viewBox="0 0 20 27" fill="none">
                                    <path
                                        d="M17.5 10.2458H16.6667V6.91252C16.6667 3.23585 13.6767 0.24585 10 0.24585C6.32333 0.24585 3.33333 3.23585 3.33333 6.91252V10.2458H2.5C1.12222 10.2458 0 11.367 0 12.7458V24.4125C0 25.7914 1.12222 26.9125 2.5 26.9125H17.5C18.8778 26.9125 20 25.7914 20 24.4125V12.7458C20 11.367 18.8778 10.2458 17.5 10.2458ZM5.55556 6.91252C5.55556 4.4614 7.54889 2.46807 10 2.46807C12.4511 2.46807 14.4444 4.4614 14.4444 6.91252V10.2458H5.55556V6.91252ZM11.1111 18.8258V21.357C11.1111 21.9703 10.6144 22.4681 10 22.4681C9.38556 22.4681 8.88889 21.9703 8.88889 21.357V18.8258C8.22778 18.4403 7.77778 17.7314 7.77778 16.9125C7.77778 15.687 8.77444 14.6903 10 14.6903C11.2256 14.6903 12.2222 15.687 12.2222 16.9125C12.2222 17.7314 11.7722 18.4403 11.1111 18.8258Z"
                                        fill="#737373"/>
                                </svg>
                                Locked
                            </div>
                            <p>Scented Trio - <br/>Air Fresheners</p>
                        </li>

                    </ul>

                </div>
            ));
};

export default Bonus3Section;